export default {
  props: {
    path: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    exact: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    collapse() {}
  }
};